import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3223dd65"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "experience-block" }
const _hoisted_2 = { class: "split-section" }
const _hoisted_3 = { class: "split-section fst-italic" }




export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceBlock',
  props: {
  companyTitle: {
    type: String,
    default: '',
  },
  workDateRange: {
    type: String,
    default: '',
  },
  jobTitle: {
    type: String,
    default: '',
  },
  jobLocation: {
    type: String,
    default: '',
  },
  sections: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(__props.companyTitle), 1),
        _createElementVNode("h3", null, _toDisplayString(__props.workDateRange), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(__props.jobTitle), 1),
        _createElementVNode("p", null, _toDisplayString(__props.jobLocation), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sections, (section) => {
        return (_openBlock(), _createElementBlock("div", {
          key: __props.companyTitle + '-' + section?.label,
          class: "experience-block-sections"
        }, [
          _createElementVNode("span", null, _toDisplayString(section?.label) + ": ", 1),
          _createElementVNode("p", null, _toDisplayString(section?.value), 1)
        ]))
      }), 128))
    ])
  ]))
}
}

})